import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { JssNodeBoolean } from '../../model/jss-tree-boolean';
import { FormArray } from '@angular/forms/src/model';

@Component({
   selector: 'app-mat-checkbox',
   templateUrl: './checkbox.component.html',
   styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit, OnChanges {

   // public to access in template directly
   public _nodeName: string = null;
   public _nodeType: string = null;
   public _title: string = null;

   public _newFormControl: FormControl = null;
   public _newFormGroup: FormGroup | FormArray = null;

   @Input() jssTreeLeaf: JssNodeBoolean;
   @Input() readonly = false;

   constructor() { }

   ngOnInit() {
   }

   ngOnChanges() {
      if (this.jssTreeLeaf && !this.jssTreeLeaf.valuePassThrough) {
         this._nodeName = this.jssTreeLeaf.nodeName;
         this._nodeType = this.jssTreeLeaf.nodeType;
         this._newFormControl = this.jssTreeLeaf.getFormControl();
         this._newFormGroup = this.jssTreeLeaf.getFormControlParent();
         this.readonly ? this._newFormControl.disable() : this._newFormControl.enable();
         // title
         if (this.jssTreeLeaf.showTitle) {
            this._title = this.jssTreeLeaf.hasTitle() ? this.jssTreeLeaf.title : this._nodeName;
         }

         // watch changes
         this._newFormControl.valueChanges.subscribe( val => {
            this.jssTreeLeaf.valueChanged(val);
         });
      }
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/checkbox/checkbox.component.ts